const steps = {
  CHOOSE: 0,
  DETAILS: 1,
  PARTICIPANTS: 2,
}

export default steps
